import PurchaseModal from './PurchaseModal';

export default PurchaseModal;
